import * as ActionTypes from '../action-types'
import Http from '../../Http'
import {CLIENTS_ROUTES} from "../../config/routes";

const user = {
    id: null,
    name: null,
    email: null,
    discount:{}
};

const initialState = {
    isAuthenticated : false,
    isAdmin: false,
    user,
    paymentsPagination: {}
};

const Auth = (state= initialState,{type,payload = null}) => {
    switch(type){
        case ActionTypes.AUTH_LOGIN:
            return authLogin(state,payload);
        case ActionTypes.AUTH_CHECK:
            return checkAuth(state);
        case ActionTypes.AUTH_LOGOUT:
            return logout(state);
        case ActionTypes.AUTH_BALANCE:
            return balance(state, payload)
        case ActionTypes.PAYMENTS:
            return setPayments(state, payload)
        default:
            return state;
    }
};

const authLogin = (state,payload) => {
    const jwtToken = payload.token;
    const user = payload.user;
    if(!!payload.user.admin){
        localStorage.setItem('is_admin',true);
    } else {
        localStorage.setItem('is_admin',false);
    }
    localStorage.setItem('jwt_token',jwtToken);
    Http.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
    state = Object.assign({}, state, {
        isAuthenticated: true,
        isAdmin: localStorage.getItem('is_admin') === 'true',
        user
    });
    return state;

};

const checkAuth = (state) =>{
    state =Object.assign({},state,{
        isAuthenticated : !!localStorage.getItem('jwt_token'),
        isAdmin : localStorage.getItem('is_admin'),
    });
    if(state.isAuthenticated){
        Http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('jwt_token')}`;
    }
    return state;
};

const logout = (state) => {
    localStorage.removeItem('jwt_token');
    localStorage.setItem('is_admin',false);
    state = Object.assign({},state,{
        isAuthenticated: false,
        isAdmin : false,
        user
    });
    return state;
};

const balance = (state, payload) => {
    return {
        ...state,
        user: payload
    }
}

const setPayments = (state, payload) => {
    return {
        ...state,
        user: {...state.user, payments: payload.list},
        paymentsPagination: payload.pagination
    }
}

export default Auth;
